var React = require('react');

function ErrorFallback (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"RipperoniError","stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd"},React.createElement("rect",{"id":"bg","stroke":"red","strokeWidth":"2","fill":"red","x":"1","y":"1","width":"320","height":"320"})));
}

ErrorFallback.defaultProps = {"viewBox":"0 0 322 322","preserveAspectRatio":"xMidYMid","style":{"fill":"currentcolor","flex":"1 1 auto"}};

module.exports = ErrorFallback;

ErrorFallback.default = ErrorFallback;
